// extracted by mini-css-extract-plugin
export default {"section":"Stars_section__l+Q4T","animateBg":"Stars_animateBg__lGIwD","animate":"Stars_animate__YOLDi"};